import React, { useState } from 'react';
import { Newspaper, Bell, Sparkles, ExternalLink, RefreshCw, Calendar } from 'lucide-react';
const newsItems = [{
  id: 1,
  title: 'FDA Announces New Labeling Requirements for Added Sugars',
  description: 'The FDA has released new guidelines requiring clearer labeling of added sugars in food products, affecting all manufacturers by 2025.',
  source: 'FDA.gov',
  date: '2 hours ago',
  type: 'regulatory',
  impact: 'high'
}, {
  id: 2,
  title: 'USDA Expands Organic Certification Oversight',
  description: 'New measures announced to strengthen the oversight of organic certification, with additional documentation requirements coming into effect.',
  source: 'USDA News',
  date: 'Yesterday',
  type: 'regulatory',
  impact: 'medium'
}, {
  id: 3,
  title: 'EU Bans Food Additive E171 (Titanium Dioxide)',
  description: 'European Food Safety Authority has banned the use of titanium dioxide (E171) as a food additive due to potential genotoxicity concerns.',
  source: 'European Commission',
  date: '3 days ago',
  type: 'international',
  impact: 'high'
}, {
  id: 4,
  title: 'New California Law Requires Plastic Packaging Reduction',
  description: 'California passes legislation requiring food manufacturers to reduce single-use plastic packaging by 25% by 2028.',
  source: 'CA.gov',
  date: '5 days ago',
  type: 'state',
  impact: 'medium'
}, {
  id: 5,
  title: 'Industry Leaders Form Sustainable Packaging Coalition',
  description: 'Major food manufacturers announce collaboration on sustainable packaging initiatives, potentially setting new industry standards.',
  source: 'Food Industry News',
  date: '1 week ago',
  type: 'industry',
  impact: 'low'
}];
export function ComplianceNews() {
  const [activeFilter, setActiveFilter] = useState('all');
  const [expandedItem, setExpandedItem] = useState<number | null>(null);
  const filteredNews = activeFilter === 'all' ? newsItems : newsItems.filter(item => item.type === activeFilter);
  const getImpactBadge = (impact: string) => {
    switch (impact) {
      case 'high':
        return 'bg-red-100 text-red-800';
      case 'medium':
        return 'bg-orange-100 text-orange-800';
      case 'low':
        return 'bg-green-100 text-green-800';
      default:
        return 'bg-gray-100 text-gray-800';
    }
  };
  const getTypeIcon = (type: string) => {
    switch (type) {
      case 'regulatory':
        return <Bell className="w-4 h-4 text-purple-600" data-id="element-209" />;
      case 'international':
        return <ExternalLink className="w-4 h-4 text-blue-600" data-id="element-210" />;
      case 'state':
        return <Calendar className="w-4 h-4 text-orange-600" data-id="element-211" />;
      case 'industry':
        return <Sparkles className="w-4 h-4 text-green-600" data-id="element-212" />;
      default:
        return <Newspaper className="w-4 h-4 text-gray-600" data-id="element-213" />;
    }
  };
  return <div className="bg-white rounded-lg border mb-8" data-id="element-214">
      <div className="p-6 border-b border-gray-200" data-id="element-215">
        <div className="flex items-center justify-between mb-2" data-id="element-216">
          <div className="flex items-center space-x-3" data-id="element-217">
            <div className="bg-purple-100 p-2 rounded-lg" data-id="element-218">
              <Newspaper className="w-5 h-5 text-purple-600" data-id="element-219" />
            </div>
            <h2 className="font-semibold text-xl text-gray-900" data-id="element-220">
              Compliance News & Updates
            </h2>
          </div>
          <button className="text-purple-600 hover:text-purple-700 flex items-center space-x-1" data-id="element-221">
            <RefreshCw className="w-4 h-4" data-id="element-222" />
            <span className="text-sm font-medium" data-id="element-223">Refresh</span>
          </button>
        </div>
        <p className="text-sm text-gray-600" data-id="element-224">
          Stay informed about the latest regulatory changes and industry news
        </p>
      </div>
      <div className="px-6 py-4 border-b border-gray-200" data-id="element-225">
        <div className="flex space-x-2 overflow-x-auto pb-2" data-id="element-226">
          <button onClick={() => setActiveFilter('all')} className={`px-3 py-1.5 text-sm font-medium rounded-full whitespace-nowrap ${activeFilter === 'all' ? 'bg-purple-100 text-purple-700' : 'bg-gray-100 text-gray-700 hover:bg-gray-200'}`} data-id="element-227">
            All Updates
          </button>
          <button onClick={() => setActiveFilter('regulatory')} className={`px-3 py-1.5 text-sm font-medium rounded-full whitespace-nowrap ${activeFilter === 'regulatory' ? 'bg-purple-100 text-purple-700' : 'bg-gray-100 text-gray-700 hover:bg-gray-200'}`} data-id="element-228">
            Regulatory Changes
          </button>
          <button onClick={() => setActiveFilter('international')} className={`px-3 py-1.5 text-sm font-medium rounded-full whitespace-nowrap ${activeFilter === 'international' ? 'bg-purple-100 text-purple-700' : 'bg-gray-100 text-gray-700 hover:bg-gray-200'}`} data-id="element-229">
            International
          </button>
          <button onClick={() => setActiveFilter('state')} className={`px-3 py-1.5 text-sm font-medium rounded-full whitespace-nowrap ${activeFilter === 'state' ? 'bg-purple-100 text-purple-700' : 'bg-gray-100 text-gray-700 hover:bg-gray-200'}`} data-id="element-230">
            State Regulations
          </button>
          <button onClick={() => setActiveFilter('industry')} className={`px-3 py-1.5 text-sm font-medium rounded-full whitespace-nowrap ${activeFilter === 'industry' ? 'bg-purple-100 text-purple-700' : 'bg-gray-100 text-gray-700 hover:bg-gray-200'}`} data-id="element-231">
            Industry Trends
          </button>
        </div>
      </div>
      <div className="divide-y" data-id="element-232">
        {filteredNews.map(item => <div key={item.id} className="p-6 hover:bg-gray-50" data-id="element-233">
            <div className="cursor-pointer" onClick={() => setExpandedItem(expandedItem === item.id ? null : item.id)} data-id="element-234">
              <div className="flex items-start justify-between mb-2" data-id="element-235">
                <div className="flex items-start space-x-3" data-id="element-236">
                  {getTypeIcon(item.type)}
                  <h3 className="font-medium text-gray-900" data-id="element-237">{item.title}</h3>
                </div>
                <span className={`inline-flex px-2 py-1 text-xs font-medium rounded-full ${getImpactBadge(item.impact)}`} data-id="element-238">
                  {item.impact.charAt(0).toUpperCase() + item.impact.slice(1)}{' '}
                  Impact
                </span>
              </div>
              <p className="text-sm text-gray-600 mb-2 ml-7" data-id="element-239">
                {item.description}
              </p>
              <div className="flex justify-between items-center ml-7" data-id="element-240">
                <div className="flex items-center space-x-3 text-xs text-gray-500" data-id="element-241">
                  <span data-id="element-242">Source: {item.source}</span>
                  <span data-id="element-243">Posted: {item.date}</span>
                </div>
                <button className="text-purple-600 hover:text-purple-700 text-sm font-medium" data-id="element-244">
                  {expandedItem === item.id ? 'Show Less' : 'Read More'}
                </button>
              </div>
            </div>
            {expandedItem === item.id && <div className="mt-4 ml-7 bg-gray-50 p-4 rounded-lg border border-gray-200" data-id="element-245">
                <h4 className="font-medium text-gray-900 mb-2" data-id="element-246">
                  Key Takeaways:
                </h4>
                <ul className="list-disc pl-5 mb-3 text-sm text-gray-700 space-y-1" data-id="element-247">
                  <li data-id="element-248">
                    This change may affect product formulation or packaging
                  </li>
                  <li data-id="element-249">
                    Compliance deadline is approaching and requires attention
                  </li>
                  <li data-id="element-250">Similar products in your catalog may need review</li>
                </ul>
                <div className="flex justify-between items-center mt-3" data-id="element-251">
                  <button className="text-purple-600 hover:text-purple-700 text-sm font-medium" data-id="element-252">
                    View Full Document
                  </button>
                  <button className="bg-purple-600 hover:bg-purple-700 text-white px-3 py-1.5 rounded-lg text-sm font-medium" data-id="element-253">
                    Analyze Impact
                  </button>
                </div>
              </div>}
          </div>)}
      </div>
      <div className="p-4 bg-gray-50 border-t border-gray-200 text-center" data-id="element-254">
        <button className="text-purple-600 hover:text-purple-700 text-sm font-medium" data-id="element-255">
          View All News & Updates
        </button>
      </div>
    </div>;
}